import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';

export const mockApiInterceptor: HttpInterceptorFn = (req, next) => {
  // Intercept requests to /api/audio-analyzer-demo
  // if (req.url.includes("/api/audio-analyzer-demo")) {
  //   const http = inject(HttpClient);
  //
  //   // Load the JSON data from assets
  //   return http.get("/assets/data/audio-analyzer-demo.json").pipe(
  //     switchMap((demoData) => {
  //       const response = new HttpResponse({
  //         body: demoData,
  //         status: 200,
  //         statusText: "OK",
  //         url: req.url,
  //       });
  //       return of(response);
  //     }),
  //   );
  // }

  // For all other requests, continue normally
  return next(req);
};
